import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from 'libs.nucleus';
/**
 * Empty-state card shown in place of a table/list when there is no data. Owns the single,
 * theme-aware placeholder look — a `bg-surface` fill and `border-neutral-200` border that both flip
 * in dark mode — so screens no longer hand-roll (and drift) their own. Provide the copy via `title`
 * (and optional `description`) and up to two buttons via `actions`.
 */
export const TablePlaceholder = ({ title, description, actions, className, dataTestId }) => {
    return (_jsxs("div", { "data-testid": dataTestId, className: [
            'flex w-full flex-col items-center justify-center gap-6 rounded-lg border border-neutral-200 bg-surface px-8 py-12 text-center',
            className,
        ]
            .filter(Boolean)
            .join(' '), children: [_jsxs("div", { className: 'flex flex-col gap-1', children: [_jsx(Text, { className: 'text-text-secondary', children: title }), description ? _jsx(Text, { className: 'text-text-secondary', children: description }) : null] }), actions ? _jsx("div", { className: 'flex flex-wrap items-center justify-center gap-3', children: actions }) : null] }));
};
